<div class="question-row">
  <div class="question-cell" style="flex-grow: 1; text-align: center;">
    Select Additional Reviewer
  </div>
</div>
<div class="question-row">
  <div class="question-cell" style="flex-grow: 1; text-align: center;">
    <select [(ngModel)]="reviewGroupId" (ngModelChange)="groupChanged()">
      @for (group of reviewGroups; track group) {
        <option [value]="group.id">{{group.displayName}}</option>
      }
    </select>
  </div>
</div>
@if (showUserSearch) {
  <div class="question-row">
    <div class="question-cell" style="flex-grow: 3;">
      Search for User:
    </div>
  </div>
  <div class="question-row">
    <div class="question-cell" style="flex-grow: 2;">
      <input [formControl]="searchControl" class="search-input" />
    </div>
  </div>
}
@if (showSearchResults) {
  <div style="position: relative; z-index: 100; background-color: #e2e2e2; opacity: 1; border: 1;">
    @if (searchResults.length === 0) {
      <div class="question-row" style="flex-grow: 1;">
        No search results found
      </div>
    }
    @for (user of searchResults; track user) {
      <div>
        <div class="question-row" style="flex-grow: 1;" (click)="selectUser(user); addUser()">
          <div class="question-cell" style="flex-grow: 1; width: 100%;">
            {{user.firstName}} {{user.lastName}}
          </div>
        </div>
      </div>
    }
  </div>
}
@for (user of selectedUsers; track user; let i = $index) {
  <div>
    <div class="question-row">
      <div class="question-cell" style="flex-grow: 1;">
        <button attr.aria-label="Remove user {{user.firstName}} {{user.lastName}}" (click)="removeUser(i)">{{user.firstName}} {{user.lastName}} <svg-icon icon="icon-x" class="small" aria-hidden="true"></svg-icon></button>
      </div>
    </div>
  </div>
}
@for (group of selectedGroups; track group; let i = $index) {
  <div>
    <div class="question-row">
      <div class="question-cell" style="flex-grow: 1;">
        <button attr.aria-label="Remove Group {{group.displayName}}"  (click)="removeGroup(i)">{{group.displayName}} <svg-icon icon="icon-x" class="small"></svg-icon></button>
      </div>
    </div>
  </div>
}
<div class="question-row">
  <div class="question-cell" style="flex-grow: 1;">
    <button class="button hollow" (click)="cancel()">Cancel</button>
  </div>
  <div class="question-cell" style="flex-grow: 1;">
    <button class="button hollow" (click)="assign()">Assign</button>
  </div>
</div>
